var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 44C26.627 44.0034 29.2287 43.4876 31.6556 42.4823C34.0826 41.477 36.2869 40.002 38.142 38.142C40.002 36.2869 41.477 34.0826 42.4823 31.6556C43.4876 29.2287 44.0034 26.627 44 24C44.0034 21.3731 43.4876 18.7714 42.4823 16.3444C41.4769 13.9175 40.0019 11.7131 38.142 9.85802C36.2869 7.99804 34.0826 6.52302 31.6556 5.5177C29.2287 4.51239 26.627 3.99661 24 4.00002C21.3731 3.99667 18.7714 4.51247 16.3444 5.51778C13.9175 6.52309 11.7131 7.99809 9.85802 9.85802C7.99809 11.7131 6.52309 13.9175 5.51778 16.3444C4.51247 18.7714 3.99667 21.3731 4.00002 24C3.99661 26.627 4.51239 29.2287 5.5177 31.6556C6.52302 34.0826 7.99804 36.2869 9.85802 38.142C11.7131 40.0019 13.9175 41.4769 16.3444 42.4823C18.7714 43.4876 21.3731 44.0034 24 44Z",
    stroke: "#09B910",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24L22 30L34 18",
    stroke: "#09B910",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.6bf995482d17cf62fb58e186298f8178.svg";
export { ForwardRef as ReactComponent };